import { useMemo, useState } from "react";
import Button from "../../design/Button";
import { CustomInput } from "../../design/components/customComponents";
import GModal from "../../design/components/GModal";
import { useSelector } from "react-redux";

const EditContactModal = ({
  visible,
  closeModalHandler,
  name,
  phoneNumber,
  saveContactHandler,
  type = "edit", // can have values add, edit
}) => {
  const maskNumbers = useSelector((state) => state?.auth?.maskNumbers);

  //States
  const [contactName, setContactName] = useState(name || "");

  const isDisabled = useMemo(() => {
    return contactName.trim() === "" || contactName === name;
  }, [contactName, name]);

  return (
    <GModal
      heading={type === "edit" ? "Edit contact" : "Add contact"}
      visible={visible}
      closeModal={() => {
        closeModalHandler();
      }}
      bodyWrapperStyle={{ paddingRight: 0 }}
      bottomButtons={[
        <Button
          hierarchy="white"
          variant="outlined"
          buttonText="Cancel"
          onClick={() => {
            closeModalHandler();
          }}
        />,
        <Button
          hierarchy="green"
          buttonText="Save"
          onClick={() => saveContactHandler(contactName, phoneNumber)}
          disabled={isDisabled}
        />,
      ]}
      body={
        <>
          <CustomInput
            label="Name"
            placeholder="Enter name"
            type="text"
            value={{ value: contactName }}
            handleChange={(e) => setContactName(e.target.value)}
          />
          {maskNumbers ? (
            ""
          ) : (
            <CustomInput
              label="Phone number"
              placeholder="Enter phone number"
              type="text"
              value={{ value: phoneNumber }}
              inputProps={{ readOnly: true, disabled: true }}
            />
          )}
        </>
      }
    />
  );
};

export default EditContactModal;
